import { combineReducers } from 'redux';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action as GroupsAction, groupsReducer as groups } from './groups';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import {
  Action as ListingsAction,
  listingsReducer as listings,
} from './listings';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action as SearchAction, searchReducer } from './search';

export type Action = GroupsAction | ListingsAction;

export const groupDashboardReducer = combineReducers<
  {
    groups: typeof groups;
    listings: typeof listings;
    search: typeof searchReducer;
  },
  GroupsAction | ListingsAction | SearchAction
>({
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  groups,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  listings,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  search: searchReducer,
});
